var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsIndexing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.6667V13.6667H3.66667V13.1667H2.66667V12.1667H3.66667V11.6667H2V10.6667H4C4.18889 10.6667 4.34722 10.7306 4.475 10.8583C4.60278 10.9861 4.66667 11.1444 4.66667 11.3333V12C4.66667 12.1889 4.60278 12.3472 4.475 12.475C4.34722 12.6028 4.18889 12.6667 4 12.6667C4.18889 12.6667 4.34722 12.7306 4.475 12.8583C4.60278 12.9861 4.66667 13.1444 4.66667 13.3333V14C4.66667 14.1889 4.60278 14.3472 4.475 14.475C4.34722 14.6028 4.18889 14.6667 4 14.6667H2ZM2 10V8.16667C2 7.97778 2.06389 7.81945 2.19167 7.69167C2.31944 7.56389 2.47778 7.5 2.66667 7.5H3.66667V7H2V6H4C4.18889 6 4.34722 6.06389 4.475 6.19167C4.60278 6.31945 4.66667 6.47778 4.66667 6.66667V7.83334C4.66667 8.02222 4.60278 8.18056 4.475 8.30834C4.34722 8.43611 4.18889 8.5 4 8.5H3V9H4.66667V10H2ZM3 5.33334V2.33334H2V1.33334H4V5.33334H3ZM6 12.6667V11.3333H14V12.6667H6ZM6 8.66667V7.33334H14V8.66667H6ZM6 4.66667V3.33334H14V4.66667H6Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsIndexing);
export default __webpack_public_path__ + "static/media/icons-indexing.620d5d16.svg";
export { ForwardRef as ReactComponent };